import { makeResetMutation } from '@utils/reset-store'
import Vue from 'vue'
import { buildInitialState } from './state'

// Mutations
export const SET_CALCULADORA_PGBL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.calculadoraPgbl.data = payload
    state.calculadoraPgbl.lastUpdate = new Date()
  }
}
export const SET_CALCULADORA_PGBLResult = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.calculadoraPgbl.result = payload
  }
}
export const ADD_CALCULADORA_PGBL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      const old = state.calculadoraPgbl.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.calculadoraPgbl.data.push(data)
      }
    })
  }
}
export const UPDATE_CALCULADORA_PGBL_SIMULATION = (state, payload) => {
  if (!payload || typeof payload !== 'object' || !payload.id) {
    return
  }

  const list = Array.isArray(state.calculadoraPgbl.data)
    ? state.calculadoraPgbl.data
    : []

  const index = list.findIndex((item) => item && item.id === payload.id)
  if (index === -1) {
    return
  }

  state.calculadoraPgbl.data.splice(index, 1, {
    ...list[index],
    ...payload,
  })
}
export const SET_CALCULADORA_PGBL_LOADING = (state, payload) => {
  state.calculadoraPgbl.loading = payload
}
export const FLUSH_CALCULADORA_PGBL_DATA = (state) => {
  if (!state.calculadoraPgbl) return
  Object.assign(state.calculadoraPgbl, {
    loading: false,
    lastUpdate: null,
    data: [],
    tableData: [],
    headers: [],
    dataDetails: {},
    resultData: {},
    loadingSave: false,
    loadingSimulation: false,
    clients: [],
    clientsLoading: false,
    clientsNameMap: {},
    irConfig: null,
    irAnosDisponiveis: [],
    irAnoSelecionado: null,
  })
}
export const SET_CALCULADORA_PGBL_VIEW = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  Object.keys(payload).forEach((key) => {
    state.calculadoraPgbl[key] = payload[key]
  })
}
export const SET_CALCULADORA_PGBL_LOADING_SIMULATION = (state, payload) => {
  state.calculadoraPgbl.loadingSimulation = payload
}
export const SET_CALCULADORA_PGBL_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.calculadoraPgbl.clients = payload
  }
}
export const SET_CALCULADORA_PGBL_CLIENTS_LOADING = (state, payload) => {
  state.calculadoraPgbl.clientsLoading = payload
}
export const SET_CALCULADORA_PGBL_CLIENTS_NAME_MAP = (state, payload) => {
  if (!state.calculadoraPgbl) return

  state.calculadoraPgbl.clientsNameMap =
    payload && typeof payload === 'object' ? payload : {}
}

export const SET_TRANSACTIONS = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const items = Array.isArray(payload.items) ? payload.items.slice() : []

  state.transactions.data = items
  state.transactions.lastUpdate = new Date()
  state.transactions.clientId = payload.clientId || null
}

// Filtro persistido de Transações/Orçamentos (objeto flat de seleção).
export const SET_FILTER_ORCAMENTOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.filterOrcamentos = payload
  }
}

export const ADD_TRANSACTION = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload

  if (!item || typeof item !== 'object') {
    return
  }

  if (clientId) {
    state.transactions.clientId = clientId
  }

  const normalized = { ...item }
  const list = Array.isArray(state.transactions.data)
    ? state.transactions.data
    : []

  const index = list.findIndex(
    (transaction) => transaction.id === normalized.id
  )

  if (index >= 0) {
    state.transactions.data.splice(index, 1, {
      ...list[index],
      ...normalized,
    })
  } else {
    state.transactions.data.push(normalized)
  }

  state.transactions.lastUpdate = new Date()
}

export const UPDATE_TRANSACTION = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload

  if (!item || typeof item !== 'object') {
    return
  }

  const list = Array.isArray(state.transactions.data)
    ? state.transactions.data
    : []

  const index = list.findIndex((transaction) => transaction.id === item.id)

  if (index === -1) {
    return
  }

  state.transactions.data.splice(index, 1, {
    ...list[index],
    ...item,
  })

  if (clientId) {
    state.transactions.clientId = clientId
  }

  state.transactions.lastUpdate = new Date()
}

export const REMOVE_TRANSACTION = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { transactionId } = payload

  if (!transactionId) {
    return
  }

  const list = Array.isArray(state.transactions.data)
    ? state.transactions.data
    : []

  const index = list.findIndex(
    (transaction) => transaction.id === transactionId
  )

  if (index === -1) {
    return
  }

  state.transactions.data.splice(index, 1)
  state.transactions.lastUpdate = new Date()
}

export const SET_TRANSACTIONS_LOADING = (state, payload) => {
  state.transactions.loading = Boolean(payload)
}

export const SET_BUDGETS = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const items = Array.isArray(payload.items) ? payload.items.slice() : []

  state.budgets.data = items
  state.budgets.lastUpdate = new Date()
  state.budgets.clientId = payload.clientId || null
}

export const RESET_BUDGETS = (state) => {
  state.budgets.data = []
  state.budgets.clientId = null
  state.budgets.lastUpdate = null
}

export const ADD_BUDGET = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload

  if (!item || typeof item !== 'object') {
    return
  }

  if (clientId) {
    state.budgets.clientId = clientId
  }

  const list = Array.isArray(state.budgets.data) ? state.budgets.data : []
  const index = list.findIndex((budget) => budget.id === item.id)

  if (index >= 0) {
    state.budgets.data.splice(index, 1, {
      ...list[index],
      ...item,
    })
  } else {
    state.budgets.data.push({ ...item })
  }

  state.budgets.lastUpdate = new Date()
}

export const UPDATE_BUDGET = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload

  if (!item || typeof item !== 'object') {
    return
  }

  const list = Array.isArray(state.budgets.data) ? state.budgets.data : []
  const index = list.findIndex((budget) => budget.id === item.id)

  if (index === -1) {
    return
  }

  state.budgets.data.splice(index, 1, {
    ...list[index],
    ...item,
  })

  if (clientId) {
    state.budgets.clientId = clientId
  }

  state.budgets.lastUpdate = new Date()
}

export const REMOVE_BUDGET = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { budgetId } = payload

  if (!budgetId) {
    return
  }

  const list = Array.isArray(state.budgets.data) ? state.budgets.data : []
  const index = list.findIndex((budget) => budget.id === budgetId)

  if (index === -1) {
    return
  }

  state.budgets.data.splice(index, 1)
  state.budgets.lastUpdate = new Date()
}

export const SET_BUDGETS_LOADING = (state, payload) => {
  state.budgets.loading = Boolean(payload)
}

const _extractGoalsItems = (payload) => {
  if (Array.isArray(payload.items)) return payload.items.slice()
  if (Array.isArray(payload.goals)) return payload.goals.slice()
  if (Array.isArray(payload.data)) return payload.data.slice()
  if (Array.isArray(payload)) return payload.slice()
  return []
}

const _extractGoalsClientId = (payload) => {
  if (payload.clientId !== undefined && payload.clientId !== null) {
    return payload.clientId
  }
  if (payload.id_cliente_app !== undefined && payload.id_cliente_app !== null) {
    return payload.id_cliente_app
  }
  return null
}

const _safeCloneRaw = (payload) => {
  try {
    // structuredClone é nativo (Node 17+/browsers modernos) e mais robusto
    // que JSON round-trip (preserva Date, Map, Set; não falha em circulares).
    if (typeof globalThis.structuredClone === 'function') {
      return globalThis.structuredClone(payload)
    }
    return JSON.parse(JSON.stringify(payload))
  } catch (error) {
    // Payload inválido para clone (ex.: ref circular sem structuredClone).
    // Log preserva contexto sem quebrar o fluxo de mutation.
    // eslint-disable-next-line no-console
    console.warn('[fp/mutations] _safeCloneRaw failed:', error && error.message)
    return null
  }
}

export const SET_GOALS = (state, payload) => {
  if (!payload || typeof payload !== 'object') return

  state.goals.data = _extractGoalsItems(payload)
  state.goals.lastUpdate = new Date()
  state.goals.clientId = _extractGoalsClientId(payload)
  state.goals.totals =
    payload.totals && typeof payload.totals === 'object'
      ? { ...payload.totals }
      : null
  state.goals.remaining =
    payload.sobra && typeof payload.sobra === 'object'
      ? { ...payload.sobra }
      : null
  state.goals.raw = _safeCloneRaw(payload)
}

export const ADD_GOAL = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload

  if (!item || typeof item !== 'object') {
    return
  }

  if (clientId) {
    state.goals.clientId = clientId
  }

  const list = Array.isArray(state.goals.data) ? state.goals.data : []
  const index = list.findIndex((goal) => goal.id === item.id)

  if (index >= 0) {
    state.goals.data.splice(index, 1, {
      ...list[index],
      ...item,
    })
  } else {
    state.goals.data.push({ ...item })
  }

  state.goals.lastUpdate = new Date()
}

export const UPDATE_GOAL = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload

  if (!item || typeof item !== 'object') {
    return
  }

  const list = Array.isArray(state.goals.data) ? state.goals.data : []
  const index = list.findIndex((goal) => goal.id === item.id)

  if (index === -1) {
    return
  }

  state.goals.data.splice(index, 1, {
    ...list[index],
    ...item,
  })

  if (clientId) {
    state.goals.clientId = clientId
  }

  state.goals.lastUpdate = new Date()
}

export const REMOVE_GOAL = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }

  const { goalId } = payload

  if (!goalId) {
    return
  }

  const list = Array.isArray(state.goals.data) ? state.goals.data : []
  const index = list.findIndex((goal) => goal.id === goalId)

  if (index === -1) {
    return
  }

  state.goals.data.splice(index, 1)
  state.goals.lastUpdate = new Date()
}

export const SET_GOALS_LOADING = (state, payload) => {
  state.goals.loading = Boolean(payload)
}

const _extractPatrimonyItems = (payload) => {
  if (Array.isArray(payload.items)) return payload.items.slice()
  if (Array.isArray(payload.data)) return payload.data.slice()
  if (Array.isArray(payload.value)) return payload.value.slice()
  return []
}

export const SET_PATRIMONY = (state, payload) => {
  if (!state.patrimony) return

  if (!payload || typeof payload !== 'object') {
    state.patrimony.data = []
    state.patrimony.clientId = null
    state.patrimony.lastUpdate = new Date()
    return
  }

  state.patrimony.data = _extractPatrimonyItems(payload)
  state.patrimony.clientId =
    payload.clientId !== undefined ? payload.clientId : null
  state.patrimony.lastUpdate = new Date()
}

export const ADD_PATRIMONY = (state, payload) => {
  if (!state.patrimony || !payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload
  if (!item || typeof item !== 'object') {
    return
  }

  const list = Array.isArray(state.patrimony.data) ? state.patrimony.data : []

  const index = list.findIndex((entry) => entry.id === item.id)

  if (index >= 0) {
    state.patrimony.data.splice(index, 1, {
      ...list[index],
      ...item,
    })
  } else {
    state.patrimony.data.push({ ...item })
  }

  if (clientId !== undefined) {
    state.patrimony.clientId = clientId
  }

  state.patrimony.lastUpdate = new Date()
}

export const UPDATE_PATRIMONY = (state, payload) => {
  if (!state.patrimony || !payload || typeof payload !== 'object') {
    return
  }

  const { item, clientId } = payload

  if (!item || typeof item !== 'object') {
    return
  }

  const list = Array.isArray(state.patrimony.data) ? state.patrimony.data : []

  const index = list.findIndex((entry) => entry.id === item.id)
  if (index === -1) {
    return
  }

  state.patrimony.data.splice(index, 1, {
    ...list[index],
    ...item,
  })

  if (clientId !== undefined) {
    state.patrimony.clientId = clientId
  }

  state.patrimony.lastUpdate = new Date()
}

export const REMOVE_PATRIMONY = (state, payload) => {
  if (!state.patrimony || !payload || typeof payload !== 'object') {
    return
  }

  const { patrimonyId } = payload
  if (!patrimonyId) {
    return
  }

  const list = Array.isArray(state.patrimony.data) ? state.patrimony.data : []

  const index = list.findIndex((entry) => entry.id === patrimonyId)
  if (index === -1) {
    return
  }

  state.patrimony.data.splice(index, 1)
  state.patrimony.lastUpdate = new Date()
}

export const SET_PATRIMONY_LOADING = (state, payload) => {
  if (!state.patrimony) {
    return
  }
  state.patrimony.loading = Boolean(payload)
}

export const SET_PATRIMONY_GOAL_LINKS = (state, payload) => {
  if (!state.patrimonyGoalLinks) {
    return
  }

  if (!payload || typeof payload !== 'object') {
    state.patrimonyGoalLinks.data = []
    state.patrimonyGoalLinks.clientId = null
    state.patrimonyGoalLinks.lastUpdate = new Date()
    return
  }

  const items = Array.isArray(payload.items)
    ? payload.items.slice()
    : Array.isArray(payload.data)
      ? payload.data.slice()
      : []

  state.patrimonyGoalLinks.data = items
  state.patrimonyGoalLinks.clientId =
    payload.clientId !== undefined ? payload.clientId : null
  state.patrimonyGoalLinks.lastUpdate = new Date()
}

export const SET_PATRIMONY_GOAL_LINKS_LOADING = (state, payload) => {
  if (!state.patrimonyGoalLinks) {
    return
  }
  state.patrimonyGoalLinks.loading = Boolean(payload)
}

export const SET_ASSET_GOAL_LINKS = (state, payload) => {
  if (!state.assetGoalLinks) {
    return
  }

  if (!payload || typeof payload !== 'object') {
    state.assetGoalLinks.data = []
    state.assetGoalLinks.clientId = null
    state.assetGoalLinks.lastUpdate = new Date()
    return
  }

  const items = Array.isArray(payload.items)
    ? payload.items.slice()
    : Array.isArray(payload.data)
      ? payload.data.slice()
      : []

  state.assetGoalLinks.data = items
  state.assetGoalLinks.clientId =
    payload.clientId !== undefined ? payload.clientId : null
  state.assetGoalLinks.lastUpdate = new Date()
}

export const SET_ASSET_GOAL_LINKS_LOADING = (state, payload) => {
  if (!state.assetGoalLinks) {
    return
  }
  state.assetGoalLinks.loading = Boolean(payload)
}

export const SET_CATEGORIES = (state, payload) => {
  if (!Array.isArray(payload)) {
    return
  }
  state.categories.data = payload.slice()
  state.categories.lastUpdate = new Date()
}

export const ADD_CATEGORY = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const list = Array.isArray(state.categories.data) ? state.categories.data : []
  const index = list.findIndex((item) => item.id === payload.id)

  if (index >= 0) {
    state.categories.data.splice(index, 1, {
      ...list[index],
      ...payload,
    })
  } else {
    state.categories.data.push({ ...payload })
  }

  state.categories.lastUpdate = new Date()
}

export const UPDATE_CATEGORY = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const list = Array.isArray(state.categories.data) ? state.categories.data : []
  const index = list.findIndex((item) => item.id === payload.id)
  if (index === -1) {
    return
  }
  state.categories.data.splice(index, 1, {
    ...list[index],
    ...payload,
  })
  state.categories.lastUpdate = new Date()
}

export const REMOVE_CATEGORY = (state, categoryId) => {
  if (!categoryId) {
    return
  }
  const list = Array.isArray(state.categories.data) ? state.categories.data : []
  const index = list.findIndex((item) => item.id === categoryId)
  if (index === -1) {
    return
  }
  state.categories.data.splice(index, 1)
  state.categories.lastUpdate = new Date()
}

export const SET_CATEGORIES_LOADING = (state, payload) => {
  state.categories.loading = Boolean(payload)
}

export const SET_SUBCATEGORIES = (state, payload) => {
  if (!Array.isArray(payload)) {
    return
  }
  state.subcategories.data = payload.slice()
  state.subcategories.lastUpdate = new Date()
}

export const ADD_SUBCATEGORY = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const list = Array.isArray(state.subcategories.data)
    ? state.subcategories.data
    : []
  const index = list.findIndex((item) => item.id === payload.id)
  if (index >= 0) {
    state.subcategories.data.splice(index, 1, {
      ...list[index],
      ...payload,
    })
  } else {
    state.subcategories.data.push({ ...payload })
  }
  state.subcategories.lastUpdate = new Date()
}

export const UPDATE_SUBCATEGORY = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const list = Array.isArray(state.subcategories.data)
    ? state.subcategories.data
    : []
  const index = list.findIndex((item) => item.id === payload.id)
  if (index === -1) {
    return
  }
  state.subcategories.data.splice(index, 1, {
    ...list[index],
    ...payload,
  })
  state.subcategories.lastUpdate = new Date()
}

export const REMOVE_SUBCATEGORY = (state, subcategoryId) => {
  if (!subcategoryId) {
    return
  }
  const list = Array.isArray(state.subcategories.data)
    ? state.subcategories.data
    : []
  const index = list.findIndex((item) => item.id === subcategoryId)
  if (index === -1) {
    return
  }
  state.subcategories.data.splice(index, 1)
  state.subcategories.lastUpdate = new Date()
}

export const SET_SUBCATEGORIES_LOADING = (state, payload) => {
  state.subcategories.loading = Boolean(payload)
}

export const SET_RULES = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const items = Array.isArray(payload.items) ? payload.items.slice() : []
  state.rules.data = items
  state.rules.clientId = payload.clientId || null
  state.rules.lastUpdate = new Date()
}

export const ADD_RULE = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const { item } = payload
  if (!item || typeof item !== 'object') {
    return
  }
  const list = Array.isArray(state.rules.data) ? state.rules.data : []
  const index = list.findIndex((rule) => rule.id === item.id)
  if (index >= 0) {
    state.rules.data.splice(index, 1, {
      ...list[index],
      ...item,
    })
  } else {
    state.rules.data.push({ ...item })
  }
  if (payload.clientId) {
    state.rules.clientId = payload.clientId
  }
  state.rules.lastUpdate = new Date()
}

export const UPDATE_RULE = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const { item, clientId } = payload
  if (!item || typeof item !== 'object') {
    return
  }
  const list = Array.isArray(state.rules.data) ? state.rules.data : []
  const index = list.findIndex((rule) => rule.id === item.id)
  if (index === -1) {
    return
  }
  state.rules.data.splice(index, 1, {
    ...list[index],
    ...item,
  })
  if (clientId) {
    state.rules.clientId = clientId
  }
  state.rules.lastUpdate = new Date()
}

export const REMOVE_RULE = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const { ruleId } = payload
  if (!ruleId) {
    return
  }
  const list = Array.isArray(state.rules.data) ? state.rules.data : []
  const index = list.findIndex((rule) => rule.id === ruleId)
  if (index === -1) {
    return
  }
  state.rules.data.splice(index, 1)
  state.rules.lastUpdate = new Date()
}

export const SET_RULES_LOADING = (state, payload) => {
  state.rules.loading = Boolean(payload)
}

export const SET_INVESTMENT_ACCOUNTS = (state, payload) => {
  if (!state.investmentAccounts) {
    return
  }

  if (!payload || typeof payload !== 'object') {
    state.investmentAccounts.data = []
    state.investmentAccounts.clientId = null
    state.investmentAccounts.lastUpdate = new Date()
    return
  }

  const items = Array.isArray(payload.items) ? payload.items.slice() : []

  state.investmentAccounts.data = items
  state.investmentAccounts.clientId =
    payload.clientId !== undefined ? payload.clientId : null
  state.investmentAccounts.lastUpdate = new Date()
}

export const SET_INVESTMENT_ACCOUNTS_LOADING = (state, payload) => {
  if (!state.investmentAccounts) {
    return
  }
  state.investmentAccounts.loading = Boolean(payload)
}

export const SET_INVESTMENT_PORTFOLIO = (state, payload) => {
  if (!state.investmentPortfolio) {
    return
  }

  if (!payload || typeof payload !== 'object') {
    state.investmentPortfolio.data = {}
    state.investmentPortfolio.clientId = null
    state.investmentPortfolio.lastUpdate = new Date()
    return
  }

  const data =
    payload.data && typeof payload.data === 'object' ? { ...payload.data } : {}

  state.investmentPortfolio.data = data
  state.investmentPortfolio.clientId =
    payload.clientId !== undefined ? payload.clientId : null
  state.investmentPortfolio.lastUpdate = new Date()
}

export const SET_INVESTMENT_PORTFOLIO_LOADING = (state, payload) => {
  if (!state.investmentPortfolio) {
    return
  }
  state.investmentPortfolio.loading = Boolean(payload)
}

export const SET_OPEN_FINANCE_CONNECTORS = (state, payload) => {
  if (!state.openFinanceConnectors) {
    state.openFinanceConnectors = {
      loading: false,
      lastUpdate: null,
      data: [],
      meta: null,
    }
  }

  state.openFinanceConnectors.data = (payload && payload.value) || []
  state.openFinanceConnectors.meta = (payload && payload.meta) || null
  state.openFinanceConnectors.lastUpdate = new Date()
}

export const SET_OPEN_FINANCE_CONNECTORS_LOADING = (state, payload) => {
  if (!state.openFinanceConnectors) {
    state.openFinanceConnectors = {
      loading: false,
      lastUpdate: null,
      data: [],
      meta: null,
    }
  }
  state.openFinanceConnectors.loading = Boolean(payload)
}

export const SET_OPEN_FINANCE_CLIENT_CONNECTORS = (state, payload) => {
  if (!state.openFinanceClientConnectors) {
    state.openFinanceClientConnectors = {
      loading: false,
      lastUpdate: null,
      data: [],
      clientId: null,
    }
  }

  // Defensive normalization — payload may arrive as:
  //   { value: [...] }                ← legacy / fluxo direto
  //   { value: { value: [...] } }     ← resposta aninhada do connector
  //   { items: [...] }                ← novo fluxo do dispatch (#1030)
  let items = []
  if (payload && payload.value && Array.isArray(payload.value.value)) {
    items = payload.value.value
  } else if (payload && Array.isArray(payload.value)) {
    items = payload.value
  } else if (payload && Array.isArray(payload.items)) {
    items = payload.items
  }

  state.openFinanceClientConnectors.data = items
  state.openFinanceClientConnectors.clientId =
    payload && payload.clientId !== undefined ? payload.clientId : null
  state.openFinanceClientConnectors.lastUpdate = new Date()
}

export const SET_OPEN_FINANCE_CLIENT_CONNECTORS_LOADING = (state, payload) => {
  if (!state.openFinanceClientConnectors) {
    state.openFinanceClientConnectors = {
      loading: false,
      lastUpdate: null,
      data: [],
      clientId: null,
    }
  }
  state.openFinanceClientConnectors.loading = Boolean(payload)
}
export const SET_RECEITAS_OU_DESPESAS = (state, payload) => {
  if (!payload || typeof payload !== 'object') {
    return
  }
  const items = Array.isArray(payload.items) ? payload.items.slice() : []
  state.receitasOuDespesas.data = items
  state.receitasOuDespesas.clientId =
    payload.clientId === undefined ? null : payload.clientId
  state.receitasOuDespesas.lastUpdate = new Date()
}
export const ADD_RECEITAS_OU_DESPESAS = (state, payload) => {
  if (!payload) return

  const _extractItem = (entry) => {
    if (!entry || typeof entry !== 'object') return null
    if (entry.item && typeof entry.item === 'object') return entry.item
    return entry
  }

  let entries = Array.isArray(payload) ? payload.slice() : [payload]
  entries = entries.map(_extractItem).filter((item) => item && item.id)

  if (!Array.isArray(state.receitasOuDespesas.data)) {
    state.receitasOuDespesas.data = []
  }

  entries.forEach((data) => {
    const list = state.receitasOuDespesas.data
    const idx = list.findIndex((item) => item.id === data.id)
    if (idx >= 0) {
      list.splice(idx, 1, { ...list[idx], ...data })
    } else {
      list.push({ ...data })
    }
  })
}
export const SET_RECEITAS_OU_DESPESAS_LOADING = (state, payload) => {
  state.receitasOuDespesas.loading = payload
}

export const SET_SIMULACOES = (state, payload) => {
  if (!payload) return
  if (Array.isArray(payload)) {
    state.simulacoes.data = payload.slice()
    state.simulacoes.lastUpdate = new Date()
    return
  }
  if (typeof payload === 'object') {
    const items = Array.isArray(payload.items) ? payload.items.slice() : []
    state.simulacoes.data = items
    if (payload.clientId !== undefined) {
      state.simulacoes.clientId = payload.clientId
    }
    state.simulacoes.lastUpdate = new Date()
  }
}
export const ADD_SIMULACOES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      const old = state.simulacoes.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.simulacoes.data.push(data)
      }
    })
  }
}
export const SET_SIMULACOES_LOADING = (state, payload) => {
  state.simulacoes.loading = payload
}

export const CLEAR_ALL_LAST_UPDATES = (state) => {
  const slices = [
    'transactions',
    'budgets',
    'goals',
    'patrimony',
    'patrimonyGoalLinks',
    'assetGoalLinks',
    'rules',
    'investmentAccounts',
    'investmentPortfolio',
    'receitasOuDespesas',
    'openFinanceClientConnectors',
    'simulacoes',
  ]
  for (const slice of slices) {
    if (state[slice]) {
      state[slice].lastUpdate = null
    }
  }
}

export const SET_RELATORIOS_INTEREST_REGISTERED = (state, payload) => {
  if (!state.preferences) {
    state.preferences = { relatoriosInterestRegistered: false }
  }
  const value = !!payload
  state.preferences.relatoriosInterestRegistered = value
  if (typeof globalThis !== 'undefined' && globalThis.localStorage) {
    if (value) {
      globalThis.localStorage.setItem(
        'fp_relatorios_interesse_registrado',
        'true'
      )
    } else {
      globalThis.localStorage.removeItem('fp_relatorios_interesse_registrado')
    }
  }
}

// Mutations do editor visual de relatório (Fase B.0.3 + B.0.5).
// Estado por cliente — chave do mapa = id_cliente_app.
function _ensureRelatorioConfigPorCliente(state, clientId) {
  if (!state.relatorioConfig) {
    state.relatorioConfig = { porCliente: {} }
  }
  if (!state.relatorioConfig.porCliente) {
    state.relatorioConfig.porCliente = {}
  }
  if (!state.relatorioConfig.porCliente[clientId]) {
    // Vue 2 não observa adição de chave nova em objeto reativo —
    // sem Vue.set, o slice fica imutável aos olhos do componente
    // e os toggles de Ativar todas / Mínimo não re-renderizam.
    Vue.set(state.relatorioConfig.porCliente, clientId, {
      secoes_ativas: {},
      comentario_consultor: '',
      comentario_encerramento: '',
    })
  }
  return state.relatorioConfig.porCliente[clientId]
}

export const SET_RELATORIO_CONFIG_SECOES_ATIVAS = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  const { clientId, secoesAtivas } = payload
  if (!clientId || !secoesAtivas || typeof secoesAtivas !== 'object') return
  const cfg = _ensureRelatorioConfigPorCliente(state, clientId)
  cfg.secoes_ativas = { ...secoesAtivas }
}

export const SET_RELATORIO_CONFIG_SECAO_ATIVA = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  const { clientId, secaoKey, ativa } = payload
  if (!clientId || !secaoKey) return
  const cfg = _ensureRelatorioConfigPorCliente(state, clientId)
  cfg.secoes_ativas = { ...cfg.secoes_ativas, [secaoKey]: !!ativa }
}

export const SET_RELATORIO_CONFIG_COMENTARIO_CONSULTOR = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  const { clientId, comentario } = payload
  if (!clientId) return
  const cfg = _ensureRelatorioConfigPorCliente(state, clientId)
  cfg.comentario_consultor = typeof comentario === 'string' ? comentario : ''
}

export const SET_RELATORIO_CONFIG_COMENTARIO_ENCERRAMENTO = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  const { clientId, comentario } = payload
  if (!clientId) return
  const cfg = _ensureRelatorioConfigPorCliente(state, clientId)
  cfg.comentario_encerramento = typeof comentario === 'string' ? comentario : ''
}

export const RESET_RELATORIO_CONFIG = (state, payload) => {
  if (!state.relatorioConfig || !state.relatorioConfig.porCliente) return
  if (payload && payload.clientId) {
    delete state.relatorioConfig.porCliente[payload.clientId]
  } else {
    state.relatorioConfig.porCliente = {}
  }
}

/**
 * Toggle local de "incluir no PDF" para um objetivo específico do
 * painel "Por objetivo" da seção Próximos Passos. Persistido por
 * cliente no slice (sem backend — decisão local do consultor).
 */
export const SET_RELATORIO_CONFIG_OBJETIVOS_EXCLUIDOS = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  const { clientId, excluidos } = payload
  if (!clientId || !Array.isArray(excluidos)) return
  const cfg = _ensureRelatorioConfigPorCliente(state, clientId)
  cfg.objetivos_excluidos = excluidos.slice()
}

export const TOGGLE_RELATORIO_CONFIG_OBJETIVO_EXCLUIDO = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  const { clientId, objetivoNome } = payload
  if (!clientId || !objetivoNome) return
  const cfg = _ensureRelatorioConfigPorCliente(state, clientId)
  const lista = Array.isArray(cfg.objetivos_excluidos)
    ? cfg.objetivos_excluidos.slice()
    : []
  const idx = lista.indexOf(objetivoNome)
  if (idx >= 0) {
    lista.splice(idx, 1)
  } else {
    lista.push(objetivoNome)
  }
  cfg.objetivos_excluidos = lista
}

// Mutations do slice office-level (Decisão 2+3 do CU-86agexp0v).

export const SET_RELATORIO_CONFIG_ESCRITORIO = (state, payload) => {
  if (!state.relatorioConfigEscritorio) {
    state.relatorioConfigEscritorio = {
      loading: false,
      loaded: false,
      secoes_ativas: {},
      comentario_consultor: '',
      comentario_encerramento: '',
    }
  }
  const cfg = state.relatorioConfigEscritorio
  const data = payload || {}
  cfg.secoes_ativas = data.secoes_ativas || {}
  cfg.comentario_consultor =
    typeof data.comentario_consultor === 'string'
      ? data.comentario_consultor
      : ''
  cfg.comentario_encerramento =
    typeof data.comentario_encerramento === 'string'
      ? data.comentario_encerramento
      : ''
  cfg.loaded = true
}

export const SET_RELATORIO_CONFIG_ESCRITORIO_LOADING = (state, loading) => {
  if (!state.relatorioConfigEscritorio) return
  state.relatorioConfigEscritorio.loading = !!loading
}

// RESET: restaura o state inicial (libera dados de cliente/escritório retidos
// entre trocas de perfil/escritório in-SPA). Reatribui cada chave a partir do
// factory — reusa a reatividade existente. [CU-86ajnmt4r]
export const RESET = makeResetMutation(buildInitialState)
